import React from 'react';
import { Box, Collapse, TableCell, TableRow } from '@material-ui/core';

import { brandTint } from 'utils/color-styles';

export const CollapsibleRow = ({
  children,
  open,
}: {
  children: React.ReactNode;
  open: boolean;
}): JSX.Element => (
  <TableRow style={{ backgroundColor: brandTint }}>
    <TableCell style={{ padding: 0 }} />
    <TableCell
      style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 0 }}
      colSpan={Number.MAX_SAFE_INTEGER}
    >
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box mb={3}>{children}</Box>
      </Collapse>
    </TableCell>
  </TableRow>
);
